<b>You are currently logged out of EZLynx.</b>
<p>Close the browser window to ensure all private information is cleared from memory.</p>
<div class="back-to-login">
  <a mat-flat-button
     [href]="postLogoutRedirectUri"
     id="btnBack"
     (click)="clearSsoLocalStorageVariables()">
    Back to login
  </a>
</div>
@if (lastSsoProvider) {
  <div class="
   sso-login">
    <mat-divider></mat-divider>
    <span>or</span>
    <a mat-flat-button
       color="accent"
       href="/auth/{{challengeUrl}}">Log in with {{ lastSsoProvider }} SSO</a>
  </div>
}
